/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ResponseApiBoolean } from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class WeiZaoGuangGaoShuJu<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags WeiZaoGuangGaoShuJu
   * @name ForgeDataUsingGet
   * @summary 伪造广告数据
   * @request GET:/dsp-admin/api/report/forgeData
   * @secure
   */
  forgeDataUsingGet = (
    query?: {
      /**
       * 广告id
       * @format int64
       */
      adId?: number;
      /** 应用id */
      appId?: string;
      /** 请求地板价 */
      bidFloor?: number;
      /**
       * 素材id
       * @format int64
       */
      creativeId?: number;
      /** 事件名 */
      eventName?: string;
      /** 媒体id */
      mediaId?: string;
      /** 追踪id */
      requestId?: string;
      /** 广告位Id */
      slotId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/report/forgeData`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new WeiZaoGuangGaoShuJu();
